import axios, { AxiosRequestConfig } from 'axios'
import { overview_resources_records_path, resources_overview_comments_path, resources_records_path, registrations_api_resources_records_path, api_resources_records_path, api_resources_record_path } from '../routes'
import { ResourcesRecordsIndexResponse, ResourcesRegistrationsResponse } from './api_data_types'

export function getResourcesOverview(payload = {}) {
  const options: AxiosRequestConfig = {
    url: overview_resources_records_path({format: 'json'}),
    method: 'get',
    responseType: 'json',
    params: payload,
  }
  return axios(options).then(response => response.data)
}

export function getResourcesRecordsRegistrations(payload = {}): Promise<{ data: ResourcesRegistrationsResponse; status: string; message: string }> {
  const options: AxiosRequestConfig = {
    url: registrations_api_resources_records_path({format: 'json'}),
    method: 'get',
    responseType: 'json',
    params: payload,
  }
  return axios(options).then(response => response.data)
}

export function createResourcesOverviewComment(payload = {}) {
  const options: AxiosRequestConfig = {
    url: resources_overview_comments_path({format: 'json'}),
    method: 'post',
    responseType: 'json',
    params: payload,
  }
  return axios(options).then(response => response.data)
}

export function createResourcesRecord(payload = {}) {
  const options: AxiosRequestConfig = {
    url: resources_records_path({format: 'json'}),
    method: 'post',
    responseType: 'json',
    data: payload,
  }
  return axios(options).then(response => response.data)
}

export function getResourcesRecordsIndex(date: string): Promise<{ data: ResourcesRecordsIndexResponse; status: string; message: string }> {
  const params: Record<string, any> = { date }

  // Ensure pretend_to_be is forwarded for impersonated sessions so the API
  // returns records for the selected user.
  if (typeof window !== 'undefined') {
    const pretendToBe = new URL(window.location.href).searchParams.get('pretend_to_be')
    if (pretendToBe) {
      params.pretend_to_be = pretendToBe
    }
  }

  const options: AxiosRequestConfig = {
    url: api_resources_records_path({format: 'json'}),
    method: 'get',
    responseType: 'json',
    params,
  }
  return axios(options).then(response => response.data)
}

export function updateResourcesRecord(id: number, payload: object) {
  const options: AxiosRequestConfig = {
    url: api_resources_record_path(id, {format: 'json'}),
    method: 'put',
    responseType: 'json',
    data: payload,
  }
  return axios(options).then(response => response.data)
}
